import React from "react";
import { History, ChevronRight } from "lucide-react";

export const AuditHistory = ({ items = [], onOpen }) => (
  <section className="pb-24" data-testid="audit-history-section">
    <div className="container-wide max-w-3xl">
      <div className="flex items-center gap-3 mb-5">
        <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary/10 text-primary">
          <History className="h-5 w-5" />
        </span>
        <h3 className="font-display text-xl font-bold text-slate-900">My Audits</h3>
      </div>
      <div className="space-y-3">
        {items.map((h) => (
          <button
            key={h.id}
            onClick={() => onOpen(h.id)}
            data-testid="audit-history-item"
            className="w-full flex items-center justify-between rounded-xl bg-white border border-slate-100 hover:border-primary hover:shadow-sm p-4 text-left transition-colors"
          >
            <div className="min-w-0">
              <p className="font-semibold text-slate-900 truncate">{h.url}</p>
              <p className="text-xs text-slate-400 mt-0.5">
                {h.created_at ? new Date(h.created_at).toLocaleString() : ""}
              </p>
            </div>
            <div className="flex items-center gap-3 shrink-0">
              {h.score != null && (
                <span className="text-sm font-semibold text-slate-600">{h.score}/100 · {h.grade}</span>
              )}
              {h.is_paid ? (
                <span className="rounded-full bg-emerald-50 px-2.5 py-1 text-xs text-emerald-700">Unlocked</span>
              ) : (
                <span className="rounded-full bg-slate-100 px-2.5 py-1 text-xs text-slate-500">Preview</span>
              )}
              <ChevronRight className="h-4 w-4 text-slate-400" />
            </div>
          </button>
        ))}
      </div>
    </div>
  </section>
);
